export const auth0Domain = process.env.GATSBY_AUTH_DOMAIN
export const auth0CustomDomain = process.env.GATSBY_AUTH_CUSTOM_DOMAIN
export const muditaAuth0Domain = process.env.GATSBY_MUDITA_AUTH_DOMAIN
export const CLDomain = process.env.GATSBY_COMMERCE_BASE_URL
export const forumClientId = process.env.GATSBY_FORUM_SIGNIN_CLIENT_ID
export const auth0Audience = auth0Domain + "/api/v2/"
export const auth0CustomDomainNoHttp =
  auth0CustomDomain && auth0CustomDomain.replace(/^https?:\/\//, "")
